import Vue from 'vue'
import VueRouter from 'vue-router'
import Transaction from '../view/Transaction.vue'
import Receipt from '../components/Receipt/index.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: "",
        name: "index",
        component: () => import("../view/app/index"),
        children: [
            {
                path: '/receipt',
                name: 'receipt',
                component: Receipt,
                meta: {
                    reload: true,
                },
            },
            {
                path: '/:transactionTsid',
                name: 'stripe',
                component: Transaction,
                meta: {
                    reload: true,
                }
            },
            {
                path: '/p/:transactionTsid',
                name: 'paypal',
                component: Transaction,
                meta: {
                    reload: true,
                }
            },
            {
                path: '/r/:transactionTsid',
                name: 'razorpay',
                component: Transaction,
                meta: {
                    reload: true,
                }
            },
        ],
    }
]

const router = new VueRouter({
    routes,
    mode: 'history',
})

export default router
